import React, { useCallback } from 'react'
import styled from 'styled-components'

import Inline from '../../layout/Inline/Inline'
import Label from '../Label/Label'
import type { FormComponent } from '../interfaces'
import { SwitchRoot, SwitchThumb } from './Switch.styles'

export interface SwitchProps extends FormComponent<boolean> {
  'data-e2e'?: string
  defaultValue?: boolean
}

const StyledLabel = styled(Label)`
  margin-bottom: 0;
`

const Switch = ({
  'data-e2e': dataE2e,
  className,
  defaultValue,
  disabled,
  helpText,
  label,
  name,
  onChange,
  required,
  value,
}: SwitchProps) => {
  const handleChange = useCallback(
    (checked: boolean) => {
      onChange?.({ name, value: checked })
    },
    [name, onChange]
  )

  return (
    <Inline alignment="center" className={className} spacing="small">
      {label && (
        <StyledLabel
          data-e2e={dataE2e ? `${dataE2e}--label` : undefined}
          helpText={helpText}
          htmlFor={name}
          required={required}
          text={label}
        />
      )}

      <SwitchRoot
        checked={value}
        data-e2e={dataE2e}
        defaultChecked={defaultValue}
        disabled={disabled}
        id={name}
        onCheckedChange={handleChange}
        value={name}
      >
        <SwitchThumb />
      </SwitchRoot>
    </Inline>
  )
}

export default Switch
